import React, { useEffect, useRef, useState } from "react";
import {
  IDataTableEquipo,
  IFilterTableEquipoPorModelo,
  initialFilterTableEquipoPorModelo,
} from "../../Interfaces/ListaVerificacion/Equipo/IEquiposCheckList";
import { IPaginacion } from "../../Interfaces/filter";
import { ISearchBox } from "@fluentui/react";
import EquipoService from "../../services/ListaVerificacion/EquipoService";
import { IException } from "../../Interfaces/base/IBase";

export const useTableEquipoPorModelo = (isOpen: boolean, modeloId?: string) => {
  const [loading, setLoading] = useState(false);
  const [dataTeble, setDataTeble] = useState<IDataTableEquipo[]>([]);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [filter, setFilter] = useState<IFilterTableEquipoPorModelo>({
    ...initialFilterTableEquipoPorModelo,
    modeloEquipoId: modeloId,
  });

  const onClickNext = () => {
    let valueSkip = filter.skip;
    setFilter({ ...filter, skip: valueSkip + 1 });
  };

  const onClickPrevius = () => {
    let valueSkip = filter.skip;
    setFilter({ ...filter, skip: valueSkip - 1 });
  };

  const searchBoxRefTable = useRef<ISearchBox>(null);
  const _onkeyUpSearch = (event: React.KeyboardEvent<HTMLInputElement>) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const postDataTableEquipoPorModelo = () => {
    EquipoService.PostListarTablaEquipoPorModelo(filter)
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setDataTeble(res.data.items);
          setPaginacion({
            page: res.data.page,
            total: res.data.total,
            pages: res.data.pages,
          });
        } else {
          setLoading(false);
        }
      })
      .catch((err: IException) => {
        setLoading(false);
        console.log(err);
      });
  };

  const onClickRefresh = () => {
    if (filter.search !== "") {
      setFilter(initialFilterTableEquipoPorModelo);
    } else {
      postDataTableEquipoPorModelo();
    }
  };

  useEffect(() => {
    if (isOpen) {
      setFilter({ ...filter, modeloEquipoId: modeloId });
    }
  }, [isOpen]);
  useEffect(() => {
    postDataTableEquipoPorModelo();
  }, [filter]);

  return {
    loading,
    dataTeble,
    paginacion,
    onClickNext,
    onClickPrevius,
    searchBoxRefTable,
    _onkeyUpSearch,
    onClickRefresh,
  };
};
